export default function AboutUs() {
  return (
    <div className="max-w-5xl mx-auto px-6 py-16 space-y-14 mt-10 md:mt-30">
      {/* Heading */}
      <div className="text-center">
        <h1 className="text-4xl md:text-5xl font-extrabold text-blue-700 mb-4">
          Nurturing Minds, Transforming Lives Since 1962
        </h1>
        <p className="text-lg text-gray-600 max-w-3xl mx-auto">
          Jivan Jyoti Trust is a non-profit organization rooted in the belief that education is the most powerful tool to break the cycle of poverty.
        </p>
      </div>

      {/* Intro */}
      <div className="space-y-4 text-gray-700 text-lg leading-relaxed">
        <p>
          Established in 1962, we have dedicated over six decades to providing quality education, holistic support, and empowerment opportunities to children and families in Ahmedabad, Gujarat, India.
        </p>
        <p>
          From humble beginnings, our initiative has grown into a recognized educational and community development effort, positively impacting thousands of lives.
        </p>
      </div>

      {/* Vision & Mission */}
      <div className="grid md:grid-cols-2 gap-8">
        <div>
          <h2 className="text-2xl font-semibold text-blue-600 mb-2">🌟 Our Vision</h2>
          <p className="text-gray-700">
            A just and equitable society where every child, regardless of background, has access to education, dignity, and a chance to reach their full potential.
          </p>
        </div>
        <div>
          <h2 className="text-2xl font-semibold text-blue-600 mb-2">🎯 Our Mission</h2>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li>To provide accessible and inclusive education to underprivileged children.</li>
            <li>To promote gender equality, especially in girls' education.</li>
            <li>To support community upliftment through literacy, vocational skills, and awareness programs.</li>
            <li>To build a compassionate, capable, and confident generation ready to shape a better future.</li>
          </ul>
        </div>
      </div>

      {/* Core Values */}
      <div>
        <h2 className="text-2xl font-semibold text-blue-600 mb-4">💡 Our Core Values</h2>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-700">
          <li><strong>🫶 Compassion:</strong> Serving with heart and humanity</li>
          <li><strong>🔍 Integrity:</strong> Honesty and transparency in all we do</li>
          <li><strong>⚖️ Equality:</strong> Empowering all, without discrimination</li>
          <li><strong>📌 Commitment:</strong> Dedicated to long-term impact</li>
          <li><strong>🏆 Excellence:</strong> Striving for high standards in education and care</li>
        </ul>
      </div>

      {/* Impact Section */}
      <div>
        <h2 className="text-2xl font-semibold text-blue-600 mb-4">📊 Our Impact at a Glance</h2>
        <ul className="space-y-3 text-gray-700 text-lg">
          <li>📚 Over 20,000 students educated since inception</li>
          <li>🎓 Alumni working as teachers, nurses, social workers, and government professionals</li>
          <li>👧 60%+ current students are girls encouraged to continue education</li>
          <li>🏫 Active in Behrampura, one of the poorest areas in Ahmedabad</li>
        </ul>
      </div>

      {/* Our Team */}
      <div>
        <h2 className="text-2xl font-semibold text-blue-600 mb-2">🤝 Our Team</h2>
        <p className="text-gray-700">
          Our team includes educators, social workers, volunteers, and community leaders — many from the same communities we serve. This ensures deep trust and long-term impact.
        </p>
      </div>

      {/* Looking Ahead */}
      <div className="bg-blue-50 p-6 rounded-xl shadow-md">
        <h2 className="text-2xl font-semibold text-blue-700 mb-2">🔭 Looking Ahead</h2>
        <p className="text-gray-700">
          We're committed to expanding our reach, enhancing programs, and building stronger partnerships. With your support, we will continue lighting the flame of knowledge and hope.
        </p>
      </div>

      {/* Footer CTA */}
      <div className="text-center space-y-2 mt-12">
        <p className="text-gray-600">📍 Based in Ahmedabad, Gujarat</p>
        <p className="text-gray-700">We welcome collaborations, donations, and volunteer involvement.</p>
        <div className="space-x-4 mt-4">
          <a href="/#contact" className="inline-block bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition">
            👉 Join Our Mission
          </a>
          <a href="/#contact" className="inline-block border border-blue-600 text-blue-600 px-6 py-2 rounded hover:bg-blue-50 transition">
            👉 Contact Us
          </a>
        </div>
        <p className="mt-6 text-sm text-gray-500">Jivan Jyoti Trust – Spreading the light of education, since 1962.</p>
      </div>
    </div>
  );
}
